import { HttpClient } from "@angular/common/http";
import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Params, Router } from "@angular/router";
// import { ConsoleReporter } from "jasmine";
import { BoardResponseModel } from "src/app/model/BoardResponseModel";
import { LotteryResponseModel } from "src/app/model/LotteryResponseModel";
import { TenementExchangeModel } from "src/app/model/TenementExchangeModel";
import { MasterService } from "src/app/services/master.service";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { Page } from "src/app/model/Page";
import { ModalComponent } from "../../corrigendum-upload/modal/modal.component";
import { ModalController } from "@ionic/angular";
import { DomSanitizer } from "@angular/platform-browser";
import { TenementModalComponent } from "../tenement-modal/tenement-modal";
import { TenementExchangeOtpModel } from "src/app/model/TenementExchangeOtpModel";

@Component({
  selector: "app-secure-lottery-au",
  templateUrl: "./tenement-exchange-form.component.html",
  styleUrls: ["./tenement-exchange-form.component.scss"],
})
export class TenementExchangeFormComponent implements OnInit {
  lotteryKey: number;
  pageMode: string;
  pageSizeOptions: number[] = [10, 25, 100, 1000];
  isLoading = false;
  isLoadingAfterSave = false;
  totalRows = 0;
  pageSize = 10;
  currentPage = 0;
  data: TenementExchangeModel;
  page: Page<TenementExchangeModel>;
  lotteryResponseModel: LotteryResponseModel;
  form: FormGroup = new FormGroup({});
  isSubmitDisabled: boolean = false;
  boardsList: { [key: number]: string };
  stageList: string[];
  paymentGatewayList: string[];
  exchangeType: string;
  showDraftList: boolean = false;
  showFinalList: boolean = false;
  showLoiBtn: boolean = false;
  showGenerateDrawResultBtn: boolean = false;
  showPolBtn: boolean = false;
  type: string;
  applicationId: number;
  schemeCode: string;
  schemeId: number;
  lotteryId: number;
  isSearchDisabled: boolean = false;
  selectedFile: File;
  approvalLetterBase64: string;
  firstApplicantTenementId: string;
  applicationNo: number;
  firstRegistrationId: number;
  incomeGroupId: number;
  annualFamilyIncome: number;
  firstSchemeId: number;
  secondSchemeId: number;
  firstIncomeGroupId: number;
  secondIncomeGroupId: number;
  secondRegistrationId: number;
  secondApplicationId: string;
  polGeneratedStatus: string;
  acceptanceStatus: string;
  applicationDrawStatus: string;

  luser: TenementExchangeOtpModel = new TenementExchangeOtpModel();
  key: number;
  dataSource: MatTableDataSource<TenementExchangeModel> =
    new MatTableDataSource();
  selectedElement: TenementExchangeModel | null = null;
  exchangeList: any[] = [
    { name: "Exchange Vacant Tenement", value: "EXCHANGE_TENEMENT" },
    {
      name: "Swap Tenement ",
      value: "SWAP_TENEMENT",
    },
  ];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  displayedColumns: string[] = [
    "checkbox",
    "id",
    "applicationNo",
    "applicantName",
    "panNumber",
    "scheme",
    // "buildingNo",
    "wing",
    "applicationDrawStatus",
    "acceptanceStatus",
    // "flatNo",
    // "floor",
  ];

  displayedColumnExchange: string[] = [
    "checkbox",
    "id",
    "scheme",
    "wing",
    // "applicationNo",
    // "applicantName",
    // "acceptanceStatus",
    "applicationDrawStatus",
  ];

  constructor(
    // @Inject(MAT_DIALOG_DATA) public data: any,
    // private boardService: MasterService,
    private masterService: MasterService,
    private _snackBar: MatSnackBar,
    private http: HttpClient,
    private route: ActivatedRoute,
    private router: Router,
    private _formBuilder: FormBuilder,
    public dialog: MatDialog,
    private modalCtrl: ModalController,
    private domSanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.route.params.subscribe((params: Params) => {
      this.applicationId = +params["applicationKey"];
      this.schemeCode = params["lotteryCode"];
      this.schemeId = +params["schemeId"];
      this.lotteryId = +params["lotteryId"];

      this.pageMode = params["pageMode"];
      this.isLoading = true;
      this.masterService.fetchTenementDetailView(this.applicationId).subscribe(
        async (data: any) => {
          this.isLoading = false;
          if (data.status === "SUCCESS") {
            this.data = data;
            this.applicationNo = data.applicationNo;
            this.firstRegistrationId = data.registrationId;
            this.incomeGroupId = data.incomeGroupId;
            this.annualFamilyIncome = data.annualFamilyIncome;
            this.firstSchemeId = data.firstSchemeId;
            this.firstIncomeGroupId = data.firstIncomeGroupId;
            this.firstApplicantTenementId = data.tenementId;
            this.polGeneratedStatus = data.polGeneratedStatus;
            this.acceptanceStatus = data.acceptSurrenderStatus;
            this.applicationDrawStatus = data.applicationDrawStatus1;
            this.key = data.key;
            this.secondApplicationId = data.secondApplicationId;

            // const typeControl = this.form.get("type");
            // const selectedTypeValue = this.data.type;
            // const selectedOption = this.exchangeList.find(
            //   (option) => option.value === selectedTypeValue
            // );

            // if (selectedOption) {
            //   typeControl.setValue(selectedOption.value);
            //   this.onStatusChange(selectedOption.value);
            // }
          } else {
            this.masterService.errorToast(data.errorMessage);
            this.router.navigate(["/secure", "tenement-exchange", "list"]);
          }
        },
        (error) => {
          this.isLoading = false;
          this.masterService.errorToast(
            error?.error?.errorMessage || error?.error?.message
          );
        }
      );
    });

    this.form = new FormGroup({
      approvalLetter: new FormControl(null, [Validators.required]),
      type: new FormControl(null, [Validators.required]),
    });
  }

  getNotAllowedTenement() {
    this.isLoading = true;
    this.masterService
      .fetchNotAllowedTenement(
        this.currentPage,
        this.pageSize,
        this.exchangeType,
        this.schemeId,
        this.applicationId,
        this.lotteryId,
        this.incomeGroupId,
        this.annualFamilyIncome
      )
      .subscribe(
        (page) => {
          this.page = page;
          this.dataSource = new MatTableDataSource(page.content);

          // this.setDefaultSelectedCheckbox();
          setTimeout(() => {
            this.paginator.pageIndex = this.currentPage;
            this.paginator.length = page.totalElements;
          });
          this.isSearchDisabled = false;
          this.isLoading = false;
        },
        (error) => {
          console.log("error", error);
          this.isLoading = false;
          this.isSearchDisabled = false;
        }
      );
  }

  setDefaultSelectedCheckbox() {
    const defaultSelectedElement = this.dataSource.data.find(
      (element) => element.secondApplicationId === this.secondApplicationId
      // console.log("+++++++++++Kiran", this.dataSource.data)
    );

    if (defaultSelectedElement) {
      defaultSelectedElement.isSelected = true;
      this.selectedElement = defaultSelectedElement;
      this.secondRegistrationId = this.selectedElement.registrationId;
    }
  }

  onStatusChange(value: any) {
    this.isSubmitDisabled = false;
    this.exchangeType = value;
    this.getNotAllowedTenement();
  }

  onSubmit() {
    // if (this.pageMode === "Add") {
    // console.log("going to save");
    this.saveExchangedTenement();
    // } else {
    //   console.log("going to update");
    //   // this.updateBoard();
    // }
  }

  async openModal() {
    if (this.exchangeType) {
      if (this.selectedFile) {
        if (this.selectedElement) {
          const modal = await this.modalCtrl.create({
            component: TenementModalComponent,
            cssClass: "master-modal-lg",
            componentProps: {
              toApplicantData: this.selectedElement,
              fromApplicantData: this.data,
              exchangeType: this.exchangeType,
            },
          });
          await modal.present();
          this.isSubmitDisabled = false;
          const { data } = await modal.onWillDismiss();

          if (data === "submit") {
            this.isLoadingAfterSave = true;
            this.saveExchangedTenement();
          }
        } else {
          this.errorToast("Please Select a Checkbox.");
          this.isSubmitDisabled = false;
        }
      } else {
        this.errorToast("Please Select a Pdf File.");
        this.isSubmitDisabled = false;
      }
    } else {
      this.errorToast("Please Select a Exchange Type.");
      this.isSubmitDisabled = false;
    }
  }

  // getOtp() {
  //   this.isSubmitDisabled = false;
  //   this.masterService.fetchOtp(this.luser).subscribe(
  //     async (data: any) => {
  //       this.isLoading = false;
  //       if (data.status === "SUCCESS") {
  //         this.data = data;
  //       } else {
  //         this.masterService.errorToast(data.errorMessage);
  //       }
  //     },
  //     (error) => {
  //       this.isLoading = false;
  //       this.masterService.errorToast(
  //         error?.error?.errorMessage || error?.error?.message
  //       );
  //     }
  //   );
  // }

  showExchangeType(o1: any, o2: any) {
    if (o1 && o2 && o1 == o2) {
      return o1;
    } else {
      return "";
    }
  }

  saveExchangedTenement() {
    let payload: any = {
      key: this.key,
      applicationNo: this.applicationNo,
      firstTenementId: this.firstApplicantTenementId,
      secondTenementId: this.selectedElement?.tenementId,
      firstApplicationId: this.applicationId,
      secondApplicationId: this.selectedElement?.secondApplicationId,
      type: this.exchangeType,
      polGeneratedStatus: this.polGeneratedStatus,
      acceptanceStatus: this.acceptanceStatus,
      secondRegistrationId: this.secondRegistrationId,
      firstRegistrationId: this.firstRegistrationId,
      firstSchemeId: this.firstSchemeId,
      firstIncomeGroupId: this.firstIncomeGroupId,
      secondSchemeId: this.selectedElement?.secondSchemeId,
      secondIncomeGroupId: this.selectedElement?.secondIncomeGroupId,
      vacantTenementId: null,
      applicationDrawStatus: this.applicationDrawStatus,
      // applicationId:this.applicationId
    };

    if (this.selectedFile) {
      payload.approvalLetter = this.approvalLetterBase64;
    } else if (this.data && this.data.approvalLetter) {
      payload.approvalLetter = this.data.approvalLetter;
    } else {
      this.errorToast("Please Select a Approval Letter.");
      return (this.isSubmitDisabled = false);
    }

    this.masterService.saveExchangedTenement(payload).subscribe(
      (data: any) => {
        if (data.status === "SUCCESS") {
          this.successToast();
          this.isLoadingAfterSave = true;
          this.router.navigate(["/secure", "tenement-exchange", "list"]);
        } else {
          this.isSubmitDisabled = false;
          this.isLoadingAfterSave = true;
          this.errorToast(data.errorMessage);
        }
      },
      (error) => {
        this.isSubmitDisabled = false;
        console.log(error);
        this.errorToast(error.error.errorMessage, 5 * 1000);
      }
    );
  }

  isValidFile(): boolean {
    return this.selectedFile && this.selectedFile.type === "application/pdf";
  }

  onFileSelect(event) {
    this.selectedFile = event.target.files[0];
    if (this.selectedFile && this.selectedFile.type === "application/pdf") {
      this.isSubmitDisabled = false;

      const reader = new FileReader();
      reader.onloadend = () => {
        this.approvalLetterBase64 = reader.result as string;
      };

      reader.readAsDataURL(this.selectedFile);
    } else {
      this.selectedFile = null; // Clear the selected file
      this.isSubmitDisabled = true;
      this.errorToast("Please select a valid PDF file.");
    }
  }

  onCheckboxChange(row: TenementExchangeModel) {
    if (row.isSelected) {
      this.isSubmitDisabled = false;
      // If the checkbox is being selected, unselect the previously selected element
      if (this.selectedElement && this.selectedElement !== row) {
        this.selectedElement.isSelected = false;
      }
      this.dataSource.data.forEach((element) => {
        element.isSelected = element === row;
      });
      this.selectedElement = row;
      this.secondRegistrationId = row.registrationId;
      console.log("this.selectedElement", this.selectedElement);
    } else {
      // If the checkbox is being deselected, clear the selected element
      this.selectedElement = null;
    }
  }

  pageChanged(event: PageEvent) {
    console.log({ event });
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.getNotAllowedTenement();
  }

  async successToast() {
    await this._snackBar.open("Tenement details saved successfully.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "success-toast",
      duration: 3 * 1000,
    });
  }

  async warningToast() {
    await this._snackBar.open("Please Upload Logo", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast(errorMessage: string, dur?: number) {
    await this._snackBar.open(errorMessage, "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: dur ? dur : 3 * 1000,
    });
  }
}
